import api from '../utils/api';

export const formService = {
    // Hero form submission (full contact details)
    submitHeroForm: async (formData) => {
        try {
            const response = await api.post('/herosection', formData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Alternative endpoint (if submit-form route exists)
    submitForm: async (formData) => {
        try {
            const response = await api.post('/email/submit-form', formData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Check if email exists
    checkEmail: async (email) => {
        try {
            const response = await api.post('/herosection/check-email', { email });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },
};
